import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Header.css";
import { Link } from 'react-router-dom';

const Header = () => {
  // 2. Initialize location
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false);

  const links = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Blog", path: "/blog" },
    { name: "Shop", path: "/shop" },
  ];

  const moreLinks = [
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Terms", path: "/terms" },
  ];

  // 3. Logic to check if any 'moreLink' is currently active
  const isMoreActive = moreLinks.some(
    (link) => location.pathname === link.path,
  );

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      {/* Left: Logo + Name */}
      <div className="left">
        <img src="/logo.jfif" alt="logo" className="logo" />
        <h2 className="title">
          <span className="brandSubtitle">Gaurav Crypto Consulting</span>
        </h2>
      </div>

      {/* Center: Nav Links */}
      <nav className="nav">
        {links.map((link) => (
          <NavLink
            key={link.name}
            to={link.path}
            className={({ isActive }) => (isActive ? "link active" : "link")}
          >
            {link.name}
          </NavLink>
        ))}
        <div
          className="more-dropdown"
          onMouseEnter={() => setIsMoreDropdownOpen(true)}
          onMouseLeave={() => setIsMoreDropdownOpen(false)}
        >
          <span className={`link ${isMoreActive ? "active" : ""}`}>More</span>
          {isMoreDropdownOpen && (
            <div className="dropdown-menu">
              {moreLinks.map((link) => (
                <NavLink
                  key={link.name}
                  to={link.path}
                  className={({ isActive }) =>
                    isActive ? "dropdown-link active" : "dropdown-link"
                  }
                  onClick={() => setIsMoreDropdownOpen(false)}
                >
                  {link.name}
                </NavLink>
              ))}
            </div>
          )}
        </div>
      </nav>

      {/* Right: Button and Menu Toggle */}
      <div className="right">
        <Link to="/shop">
          <button className="button">Book Now</button>
        </Link>
        <div className="menuToggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobileMenu ${isMenuOpen ? "open" : ""}`}>
        {links.map((link) => (
          <NavLink
            key={link.name}
            to={link.path}
            className={({ isActive }) =>
              isActive ? "mobileLink active" : "mobileLink"
            }
            onClick={() => setIsMenuOpen(false)}
          >
            {link.name}
          </NavLink>
        ))}
        <div className="mobile-more-section">
          <div className="mobile-more-title">More</div>
          {moreLinks.map((link) => (
            <NavLink
              key={link.name}
              to={link.path}
              className={({ isActive }) =>
                isActive ? "mobileLink active" : "mobileLink"
              }
              onClick={() => setIsMenuOpen(false)}
            >
              {link.name}
            </NavLink>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
